'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutType, Types } from '@shared/all/domains/spaces';
import toast from '@shared/utils/helpers/toast';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { client } from '../../utils/trpc';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
import Dropdown from '../UI/DropDown';
import Input from '../UI/Input';
import Switch from '../UI/Switch';
type Props = {
  closeHandler: () => void;
  // Fires after a successful create, before navigating to the new space
  onCreated?: () => void;
};
const NewSpace = t0 => {
  const $ = _c(79);
  const {
    closeHandler,
    onCreated
  } = t0;
  const router = useRouter();
  const [spaceName, setSpaceName] = useState("");
  const [error, setError] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [isInvite, setIsInvite] = useState(false);
  const [defaultLayout, setDefaultLayout] = useState(LayoutType.Space);
  let t1;
  if ($[0] !== isInvite || $[1] !== isPremium || $[2] !== isPrivate) {
    t1 = () => [isPrivate ? Types.PRIVATE : undefined, isPremium ? Types.PREMIUM : undefined, isInvite ? Types.INVITE : undefined].filter(_temp);
    $[0] = isInvite;
    $[1] = isPremium;
    $[2] = isPrivate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const spaceTypesArray = t1;
  let t2;
  if ($[4] !== defaultLayout || $[5] !== onCreated || $[6] !== router || $[7] !== spaceName || $[8] !== spaceTypesArray) {
    t2 = async () => {
      if (!spaceName) {
        return;
      }
      if (spaceName.length < 3) {
        return toast("Name must be at least 3 characters", "", "error");
      }
      const [error_0] = await client.spaces.create.mutate({
        name: spaceName,
        types: spaceTypesArray(),
        defaultLayout: defaultLayout || undefined
      });
      if (error_0) {
        return;
      }
      const slug = spaceName.toLowerCase().replaceAll(" ", "-").replaceAll(/[^A-Za-z0-9-]+/g, "").replace(/-$/, "");
      onCreated?.();
      router.push(`/s/${slug}`);
    };
    $[4] = defaultLayout;
    $[5] = onCreated;
    $[6] = router;
    $[7] = spaceName;
    $[8] = spaceTypesArray;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const submitHandler = t2;
  let t3;
  if ($[10] !== spaceName) {
    t3 = () => {
      if (spaceName.endsWith("-")) {
        return setError("Name can only end with alphanumerical characters");
      }
      if (!spaceName.endsWith("-")) {
        return setError("");
      }
    };
    $[10] = spaceName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  useEffect(t3);
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => {
      if (value.length > 21) {
        return;
      }
      setSpaceName(value);
    };
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const changeHandler = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ModalHeader><h2>New Space</h2></ModalHeader>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== spaceName) {
    t6 = <Input type="text" label="Name" value={spaceName} onChange={changeHandler} autofocus={true} />;
    $[14] = spaceName;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = spaceName ? `${21 - spaceName.length} characters remaining.` : "The name of a space cannot be changed later.";
  let t8;
  if ($[16] !== t7) {
    t8 = <p className="my-2 text-base text-textSecondary/60">{t7}</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== spaceName) {
    t9 = spaceName ? `${process.env.NEXT_PUBLIC_SITE_URL}/s/${spaceName.toLowerCase().replaceAll(" ", "-").replaceAll(/[^A-Za-z0-9-]+/g, "").replace(/-$/, "")}` : `${process.env.NEXT_PUBLIC_SITE_URL}/s/your-space-url`;
    $[18] = spaceName;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <Input type="text" label="URL" value={t9} disabled={true} />;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <label className="text-sm font-emphasis text-textPrimary">Default Layout</label>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [{
      value: LayoutType.Space,
      label: "Space"
    }, {
      value: LayoutType.Board,
      label: "Board"
    }];
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = option => setDefaultLayout(option ? option.value as LayoutType : LayoutType.Space);
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== defaultLayout) {
    t14 = <Dropdown options={t12} selectedValue={defaultLayout} onSelect={t13} placeholder="Select layout type" disabled={false} />;
    $[25] = defaultLayout;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="text-xs text-textSecondary/70">Which layout the space opens on. Both stay available — anyone can switch from the space header, and you can change this later in Manage Space.</p>;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== defaultLayout) {
    t16 = defaultLayout === LayoutType.Board && <div className="mt-2 rounded-lg border border-primary/20 bg-primary/5 p-3"><p className="mb-2 text-xs font-emphasis text-textPrimary">💡 Tip: After creating your board, you can import lists and cards from Trello!</p></div>;
    $[28] = defaultLayout;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t14 || $[31] !== t16) {
    t17 = <div className="space-y-2">{t11}{t14}{t15}{t16}</div>;
    $[30] = t14;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <p>Space Type</p>;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsPrivate(_temp2);
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== isPrivate) {
    t20 = <Switch onChange={t19} state={isPrivate} />;
    $[35] = isPrivate;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <label>Private</label>;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20) {
    t22 = <div className="flex space-x-2">{t20}{t21}</div>;
    $[38] = t20;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setIsPremium(_temp3);
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== isPremium) {
    t24 = <Switch onChange={t23} state={isPremium} />;
    $[41] = isPremium;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <label>Premium</label>;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t24) {
    t26 = <div className="flex space-x-2">{t24}{t25}</div>;
    $[44] = t24;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = () => setIsInvite(_temp4);
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== isInvite) {
    t28 = <Switch onChange={t27} state={isInvite} />;
    $[47] = isInvite;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <label>Invite-Only</label>;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t28) {
    t30 = <div className="flex space-x-2">{t28}{t29}</div>;
    $[50] = t28;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t22 || $[53] !== t26 || $[54] !== t30) {
    t31 = <div className="space-y-2">{t18}<div className="flex space-x-4">{t22}{t26}{t30}</div></div>;
    $[52] = t22;
    $[53] = t26;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== t17 || $[57] !== t31) {
    t32 = <div className="space-y-4 py-4">{t17}{t31}</div>;
    $[56] = t17;
    $[57] = t31;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t10 || $[60] !== t32 || $[61] !== t6 || $[62] !== t8) {
    t33 = <ModalContent>{t6}{t8}{t10}{t32}</ModalContent>;
    $[59] = t10;
    $[60] = t32;
    $[61] = t6;
    $[62] = t8;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== closeHandler) {
    t34 = <Button text="Cancel" variant="SECONDARY" borderTransparent={false} onClick={closeHandler} />;
    $[64] = closeHandler;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== error || $[67] !== spaceName) {
    t35 = spaceName.trim().length < 3 || Boolean(error);
    $[66] = error;
    $[67] = spaceName;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== submitHandler || $[70] !== t35) {
    t36 = <Button text="Create" disabled={t35} onClick={submitHandler} />;
    $[69] = submitHandler;
    $[70] = t35;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== t34 || $[73] !== t36) {
    t37 = <ModalFooter>{t34}{t36}</ModalFooter>;
    $[72] = t34;
    $[73] = t36;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== closeHandler || $[76] !== t33 || $[77] !== t37) {
    t38 = <Modal closeHandler={closeHandler}>{t5}{t33}{t37}</Modal>;
    $[75] = closeHandler;
    $[76] = t33;
    $[77] = t37;
    $[78] = t38;
  } else {
    t38 = $[78];
  }
  return t38;
};
export default NewSpace;
function _temp(x) {
  return x !== undefined;
}
function _temp2(x_0) {
  return !x_0;
}
function _temp3(x_1) {
  return !x_1;
}
function _temp4(x_2) {
  return !x_2;
}